import React, {useCallback, useContext, useEffect, useRef} from 'react';
import {useLocation} from 'react-router-dom';

import {BroadcastContext} from 'src/contexts/brodcast-context';
import {AUTH_CALLBACK_EVENTS} from
    'src/modules/profile/account/tabs/license-and-features/crm-tab/constants';

import Loading from '@pb/kit-component-loading';

import {useSaveSalesforceAuth} from './useSaveSalesforceAuth';

export const SalesforceOauthCallback = () => {
    const {search} = useLocation();
    const {sendMessage} = useContext(BroadcastContext);
    const isProcessed = useRef(false);

    const broadcastAndClose = useCallback(
        (result: {success: boolean, error?: string}) => {
            sendMessage(JSON.stringify({
                [AUTH_CALLBACK_EVENTS.SALESFORCE]: result,
            }));
            window.close();
        },
        [sendMessage],
    );

    const {
        isLoading: isSaveBusy,
        action: saveSalesforceAuthCredentials,
    } = useSaveSalesforceAuth({
        onSuccess: () => broadcastAndClose({success: true}),
        onFailure: error => broadcastAndClose({success: false, error}),
    });

    useEffect(() => {
        if (isProcessed.current) {
            return;
        }

        const params = new URLSearchParams(search.slice(1));
        const code = params.get('code');
        const stateString = params.get('state');
        const error = params.get('error');
        let accountId = null;

        let codeVerifier = null;
        if (stateString) {
            try {
                const parsedState = JSON.parse(
                    decodeURIComponent(stateString),
                );
                accountId = parsedState.accountId;
                codeVerifier = parsedState.codeVerifier;
            } catch (e) {
                console.error(e);
            }
        }

        if (error) {
            isProcessed.current = true;
            broadcastAndClose({success: false, error: 'Access Denied'});
        } else if (code && accountId) {
            isProcessed.current = true;
            saveSalesforceAuthCredentials({code, accountId, codeVerifier});
        }
    }, [search, saveSalesforceAuthCredentials, broadcastAndClose]);

    return isSaveBusy ? <Loading fast={true}/> : null;
};

